class MatchPrintsController {
  constructor(MatchesFactory, $rootScope, Permissions) {
    "ngInject";
    const vm = this;

    vm.$onInit = () => {
      vm.rootScope = $rootScope;
      vm.eliminationTypes = MatchesFactory.MATCH_ELIMINATION_TYPES;
      vm.matchLeagues = [];
      vm.mixedLeagues = [];
      vm.options = [
        {
          id: 1,
          name: "LEAGUES_LIST",
          action: MatchesFactory.MATCH_PRINTS.LEAGUES_LIST,
        },
        {
          id: 2,
          name: "PLAYERS_LIST",
          action: MatchesFactory.MATCH_PRINTS.PLAYERS_LIST,
        },
        {
          id: 3,
          name: "TEAMS_LIST",
          action: MatchesFactory.MATCH_PRINTS.TEAMS_LIST,
        },
        {
          id: 4,
          name: "TARGETS_LIST",
          action: MatchesFactory.MATCH_PRINTS.TARGETS_LIST,
        },
        {
          id: 5,
          name: "QUALIFICATION",
          action: MatchesFactory.MATCH_PRINTS.QUALIFICATION,
        },
        {
          id: 6,
          name: "MEDALS",
          action: MatchesFactory.MATCH_PRINTS.MEDALS,
        },
        {
          id: 7,
          name: "QR",
          action: MatchesFactory.MATCH_PRINTS.QR,
        },
        {
          id: 8,
          name: "ELIMINATION_ROUNDS",
        },
        {
          id: 9,
          name: "TARGETS_BOARDS",
          action: MatchesFactory.MATCH_PRINTS.TARGETS_BOARDS,
        },
        // {
        // 	id: 10,
        // 	name: 'EXCEL',
        // 	action: MatchesFactory.MATCH_PRINTS.EXCEL,
        // 	premium: true
        // },
        // {
        // 	id: 11,
        // 	name: 'IMPORT',
        // 	action: MatchesFactory.MATCH_PRINTS.EXCEL_IMPORT,
        // 	premium: true
        // },
        {
          id: 12,
          name: "TEAM_ENTRIES_LIST",
          action: MatchesFactory.MATCH_PRINTS.TEAM_ENTRIES_LIST,
        },
        {
          id: 13,
          name: "ATHLETES_SCORECARDS",
          action: MatchesFactory.MATCH_PRINTS.ATHLETES_SCORECARDS,
        },
        {
          id: 14,
          name: "ATHLETES_MATCH_CARDS",
          action: MatchesFactory.MATCH_PRINTS.ATHLETES_MATCH_CARDS,
        },
        {
          id: 15,
          name: "CERTIFICATES",
          action: MatchesFactory.MATCH_PRINTS.CERTIFICATES,
        },
        {
          id: 16,
          name: "ATHLETE_MATCH_ENTRY_CARDS",
          action: MatchesFactory.MATCH_PRINTS.ATHLETE_MATCH_ENTRY_CARDS,
        },
      ];
      if (vm.rootScope.user.isUserTypeTeam()) {
        vm.options = vm.options.filter((option) => option.id === 16);
      } else if (!$rootScope.user.canDo(Permissions.MATCH_PRINTS)) {
        vm.options = [];
      }
      vm.activeOption = 0;
      MatchesFactory.getOne(vm.rootScope.currentMatchId, {
        include: "matchLeagues",
      }).then((response) => {
        let includedMixedLeauges = [];
        vm.matchLeagues = response.data.matchLeagues;
        Object.entries(vm.matchLeagues).forEach((entry) => {
          let value = entry[1];
          if (value.olympic_mixed > 0) {
            if (!includedMixedLeauges.includes(value.league_id)) {
              vm.mixedLeagues.push(value);
              includedMixedLeauges.push(value.league.league_id);
              includedMixedLeauges.push(value.league.mixed_league_id);
            }
          }
        });
      });
    };

    vm.selectOption = (option) => {
      if (option.action === MatchesFactory.MATCH_PRINTS.EXCEL_IMPORT) {
        MatchesFactory.addShotsFromExcel(vm.rootScope.currentMatchId).then(
          (response) => {
            ngDialog.open({ template: "successTemplate" });
          }
        );
      } else if (option.action) {
        vm.getPrintPDF(option.action);
      } else {
        vm.activeOption = option.id;
      }
    };

    vm.selectedPrint = null;
    vm.getPrintPDF = (print) => {
      if (print) {
        vm.selectedPrint = print;
      }
      const tabWindowId = window.open("about:blank", "_blank");
      MatchesFactory.prints(vm.rootScope.currentMatchId, vm.selectedPrint).then(
        (response) => {
          let file = new Blob([response.data], { type: "application/pdf" });
          tabWindowId.location.href = window.URL.createObjectURL(file);
        }
      );
    };

    vm.getEliminationsPrintPDF = (leagueId, eliminationType) => {
      const tabWindowId = window.open("about:blank", "_blank");
      MatchesFactory.printsElimination(
        vm.rootScope.currentMatchId,
        leagueId,
        eliminationType
      ).then((response) => {
        let file = new Blob([response.data], { type: "application/pdf" });
        tabWindowId.location.href = window.URL.createObjectURL(file);
      });
    };

    vm.getEliminationsTargetBoardsPDF = (leagueId, eliminationType, round) => {
      const tabWindowId = window.open("about:blank", "_blank");
      MatchesFactory.printsEliminationTargetBoards(
        vm.rootScope.currentMatchId,
        leagueId,
        eliminationType,
        round.replace("1/", "")
      ).then((response) => {
        let file = new Blob([response.data], { type: "application/pdf" });
        tabWindowId.location.href = window.URL.createObjectURL(file);
      });
    };
  }
}

export default MatchPrintsController;



// WEBPACK FOOTER //
// ./client/app/components/matches/matchProfile/matchPrints/matchPrints.controller.js